import { render, staticRenderFns } from "./SurveyAcknowledgement.vue?vue&type=template&id=b47e2a7a&"
import script from "./SurveyAcknowledgement.vue?vue&type=script&lang=ts&"
export * from "./SurveyAcknowledgement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports